import axios from 'axios';
import * as globals from '../globals';

/**
 * Get auth token from localStorage
 * @returns The auth token string or null if not found
 */
const getAuthToken = (): string | null => {
  const sessionInfo = localStorage.getItem('mygolf2uapp.sessionInfo');
  if (sessionInfo) {
    try {
      const session = JSON.parse(sessionInfo);
      return session.authToken || null;
    } catch (e) {
      console.error('Error parsing session info:', e);
      return null;
    }
  }
  return null;
};

/**
 * Request interceptor - adds X-AUTH-TOKEN header to all axios requests
 */
axios.interceptors.request.use(
  config => {
    const token = getAuthToken();
    if (token) {
      config.headers[globals.AUTH_TOKEN_NAME] = token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

/**
 * Response interceptor for error handling
 */
axios.interceptors.response.use(
  response => response,
  error => {
    // Handle 401 unauthorized errors
    if (error.response && error.response.status === 401) {
      console.error('Unauthorized - token may be expired');
      // Optionally redirect to login or refresh token here
    }
    return Promise.reject(error);
  }
);

export default axios;
